import React from 'react';
import { Modal, View, Text, TouchableOpacity } from 'react-native';
import { styles } from './DbAlertDialog.styles';
import { DbAlertDialogProps } from './DbAlertDialog.types';
export const DbAlertDialog: React.FC<DbAlertDialogProps> = ({
    visible,
    title = '提示',
    message,
    confirmText = '确定',
    onConfirm,
    cancelText,
    onCancel,
}) => {
    return (
        <Modal
            visible={visible}
            transparent
            animationType="fade"
            onRequestClose={onCancel}
        >
            <View style={styles.overlay}>
                <View style={styles.dialog}>
                    {title ? <Text style={styles.title}>{title}</Text> : null}
                    <Text style={styles.message}>{message}</Text>
                    <View style={styles.buttonRow}>
                        {cancelText ? (
                            <TouchableOpacity style={styles.button} onPress={onCancel}>
                                <Text style={styles.cancelText}>{cancelText}</Text>
                            </TouchableOpacity>
                        ) : null}
                        <TouchableOpacity style={styles.button} onPress={onConfirm}>
                            <Text style={styles.confirmText}>{confirmText}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        </Modal>
    );
};


export default DbAlertDialog;
